<template>
  <div name="demo-searchbox-codempid">
    <div class="row">
      <div class="form-group col-xs-12 col-md-6">
        <hrms-lov v-model="codempid1"
                  lovType="codempid"
                  :disabled="false"
                  :nowLang="nowLang"
                  name="codempid1"
                  :descDisp="false" />
        <hrms-lov v-model="codempid2"
                  lovType="codempid"
                  :disabled="true"
                  :nowLang="nowLang"
                  name="codempid2" />
        <hrms-lov v-model="codempid3"
                  lovType="codempid"
                  :disabled="false"
                  :nowLang="nowLang"
                  name="codempid2" />
      </div>
    </div>
    <hrms-search-box	 :receivedStore="receivedStore"
                			 :nowLang="nowLang"
                			 :searchBoxAlias="searchBoxAlias" />
  </div>
</template>

<script>
import env from 'src/../env.js'

export default {
  name: 'demo-searchbox-codempid',
  data () {
    return {
      codempid1: '',
      codempid2: '',
      codempid3: '',
      nowLang: window.localStorage.getItem(env.site + '_lang'),
      searchBoxAlias: 'demo-lov-codempid'
    }
  },
  methods: {
    receivedStore (params) {
      console.log(params)
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoSearchboxCodempid.vue?91e7450e